module.exports = __webpack_public_path__ + "static/media/shopware-logo.536a0bbd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/images/shopware-logo.svg
// module id = 616
// module chunks = 0